// extracted by mini-css-extract-plugin
module.exports = {"bannerLogoutContainer":"styles_bannerLogoutContainer__oxxN8"};